;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import get from "lodash/get"
import SectionHeader from "../shared/SectionHeader"
import { PROFILE_YOUR_STORY } from "../../../../lib/constants"
import descriptionWithNewLines from "../../../../lib/formatter/descriptionWithNewLines"

export default function Story(props) {
  const { provider } = props
  const yourStory = get(provider, `profileContent[${PROFILE_YOUR_STORY}]`, false)

  return yourStory ? (
    <div className={`flex justify-center items-center w-full text-black`}>
      <div className={`max-w-[1054px] w-full mx-[15px] min-[600px]:mx-[24px]`}>
        <SectionHeader text={"my Story"} />
        <div
          className={
            "font-roboto text-[20px] tracking-[.6px] leading-[150%] mb-[40px] whitespace-pre-wrap"
          }
        >
          {descriptionWithNewLines(yourStory, "your-story")}
        </div>
      </div>
    </div>
  ) : null
}
